<template>
	<div class="pagesContent">
		<!-- 外层容器 -->
		<el-container>
			<!-- 顶栏容器 -->
			<el-header height="100px">
				<el-card>
					<el-row>
						<el-col :span="22">
							<h4><i class="el-icon-notebook-2"></i> 穿透云主机</h4>
						</el-col>
						<el-col :span="2">
							<el-button type="primary" size="medium" icon="el-icon-plus" @click="dialogAdd = true">添加</el-button>
						</el-col>
					</el-row>
				</el-card>
			</el-header>
			<!-- 主体内容 -->
			<el-main class="main-box">
				<el-card>
					<!-- 表格  条纹 stripe 边框 border -->
					<el-table style="width: 100%;" ref="frpTable" :data="frpData" highlight-current-row stripe>
						<el-table-column prop="Id" label="编号" align="center" min-width="50">
						</el-table-column>
						<el-table-column prop="ServerAddress" label="服务器地址" min-width="150" align="center">
						</el-table-column>
						<el-table-column prop="ServerPort" label="服务器端口" min-width="100" align="center">
						</el-table-column>
						<el-table-column prop="Token" label="服务器口令" header-align="center" min-width="200" align="center">
						</el-table-column>
						<!-- 编辑状态才显示按钮 -->
						<el-table-column label="操作" min-width="100" align="center">
							<template slot-scope="{row, $index}">
								<div>
									<el-button size="mini" type="danger" @click="delRow(row,$index)">删除</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-main>
			
			<!-- 弹出框 单个添加穿透服务器 -->
			<el-dialog title="添加穿透云主机" :visible.sync="dialogAdd" width="35%" @close="onCloseAdd" :close-on-click-modal='false'>
				<!-- :center="true"   居中 -->
				<div class="dialog-body-add">
					<el-form :model="form" label-position="right" label-width="100px" autocomplete="off" ref="form" :rules="AddRules">
						<el-form-item label="服务器地址" prop="ServerAddress">
							<el-col :span="16">
								<el-input v-model="form.ServerAddress" placeholder="请输入服务器地址"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="服务器端口" prop="ServerPort">
							<el-col :span="16">
								<el-input v-model="form.ServerPort" placeholder="请输入服务器端口"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="服务器口令" prop="Token">
							<el-col :span="16">
								<el-input v-model="form.Token" placeholder="请输入服务器口令">
								</el-input>
							</el-col>
						</el-form-item>
					</el-form>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogAdd = false">取 消</el-button>
					<el-button type="primary" @click="submitAdd()">确 定</el-button>
				</div>
			</el-dialog>

		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//弹出框 单个添加穿透服务器
				dialogAdd: false,
				//弹出框  客户端
				dialogFormVisibleUpdate: false,
				//客户端穿透列表
				clientData: [{
						frpsId: '123', // frps编号
						type: 1, //穿透类型
						local_ip: '192.168.1.1', //
						local_port: '8080', //客户端端口
						use_encryption: false, //消息加密
						use_gzip: false, //消息压缩
						custom_domains: '自定义域名', //自定义域名
						remote_port: '远程端口', //远程端口
					},
					{
						frpsId: '123',
						type: 1,
						local_ip: '192.168.1.1',
						local_port: '8080',
						use_encryption: false,
						use_gzip: false,
						custom_domains: '自定义域名',
						remote_port: '远程端口',
					}
				],
				//穿透服务器列表
				frpData: [
					// {
					// 	Id: 1, // 编号
					// 	ServerAddress: '服务器地址', // 	服务器地址
					// 	ServerPort: '服务器端口', // 	服务器端口
					// 	Token: '服务器口令', // 	服务器口令
					// }
				],
				//编辑表格 定义为数组
				editFrpTable: [],
				CeditFrpTable: [],
				//当前行 索引
				index: '',
				Cindex: '',
				timer: null,
				Ctimer: null,
				//获得焦点、失去焦点（用来控制单击事件的弹窗）
				focus: false,
				blur: false,
				btn: false,
				Cbtn: false,
				//单个添加穿透服务器
				form: {
					ServerAddress: '', //服务器地址
					ServerPort: '', //服务器端口
					Token: '', //服务器口令
				},
				//表单验证规则  单个添加穿透服务器
				AddRules: {
					ServerAddress: [
						{ required: true, message: '请输入服务器地址', trigger: 'blur' },
						{ max:20, message: '最多输入20个字符', trigger: 'blur' },
					],
					ServerPort: [
						{ required: true, message: '请输入服务器端口', trigger: 'blur' },
						{ max:6, message: '最多输入6个字符', trigger: 'blur' },
					],
					Token: [
						{ required: true, message: '请输入服务器口令', trigger: 'blur' },
						{ max:100, message: '最多输入100个字符', trigger: 'blur' },
					],
				},

			}
		},
		mounted() {
			//查询所有frp穿透配置信息
			this.getFrpAll()
		},
		methods: {
			// 删除云主机
			delRow(row,ind){
				this.$confirm('是否删除该云主机？', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					var data = `?address=${ row.ServerAddress }&port=${ row.ServerPort }`
					this.$http.delFrpServer(data).then(res=>{
						// return console.log(res);
						if(res.data.Code!=200) return this.$message.error(res.data.MsgText)
						this.$message.success('删除成功！')
						this.frpData.splice(ind,1)
					})
					
				}).catch()
			},
			
			//查询所有frp穿透配置信息
			getFrpAll() {
				this.$http.getFrpAll().then(res => {
					// return console.log(res)
					if(res.status!=200) return this.$message.error(res.data.MsgText)
					this.frpData = res.data
				})
			},
			
			//提交(单个添加穿透服务器)
			submitAdd() {
				//表单验证
				this.$refs.form.validate((valid) => {
					if(!valid) return this.$message.warning('请检查页面错误')
					this.$http.addFrpSingle(this.form).then(res => {
						// console.log(res)
						if(res.data.Code!=200) return this.$message.error(res.data.MsgText)
						this.$message.success('添加成功')
						//关闭弹框
						this.dialogAdd = false
						//查询所有frp穿透配置信息
						this.getFrpAll()
					})
				});
			},
			// 添加 弹窗关闭时重置表单
			onCloseAdd() {
				this.$refs.form.resetFields()
			},
		}
	}
</script>

<style scoped>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		width: 100%;
		background-color: #FFFFFF;
	}

	/*单击表格单条信息 弹框样式 */
	.dialog-body {
		height: 60vh;
		box-sizing: border-box;
		overflow: auto;
		/* 超出滑动 */
		padding: 30px;
	}

	/* 单个添加 弹框样式 */
	.dialog-body-add {
		height: 40vh;
		box-sizing: border-box;
		padding: 0 40px 0 80px;
	}

	/* 勾选框 */
	.el-checkbox /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
		border-color: #409EFF;
		background-color: #409EFF;
	}

	.el-checkbox /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
		border-color: #FFFFFF;
	}
</style>
